export default __webpack_public_path__ + "static/media/collage-2.f3aaf914.png";